import { BaseDto } from '../base.dto';
import { Exclude } from 'class-transformer';
import { IsDefined, IsNumber, IsOptional } from 'class-validator';
import { BankingCashUpMultiCurrencyDto } from '../banking-cash-up-multicurrency';
import { MerchantDto } from '../merchant.dto';
import { UserDto } from '../user.dto';

export class CashUpReportDto extends BaseDto {
  @Exclude()
  merchantId: number;
  @Exclude()
  cashUpDate: string;
  @Exclude()
  closedDay?: number;
  @Exclude()
  closedDayTime?: string;
  @IsDefined()
  @IsNumber()
  reconCash1: number;
  @IsDefined()
  @IsNumber()
  reconCash2: number;
  @IsDefined()
  @IsNumber()
  reconCreditCard1: number;
  @IsDefined()
  @IsNumber()
  reconCreditCard2: number;
  @IsDefined()
  @IsNumber()
  reconCreditCard3: number;
  @IsDefined()
  @IsNumber()
  reconCreditCard4: number;
  @IsDefined()
  @IsNumber()
  reconCreditCard5: number;
  @IsOptional()
  @IsNumber()
  reconDeliveroo: number;
  @IsOptional()
  @IsNumber()
  reconJustEat: number;
  @IsOptional()
  @IsNumber()
  reconUber: number;
  @IsDefined()
  @IsNumber()
  reconOwnOnline: number;
  @IsDefined()
  @IsNumber()
  reconOtherOnline: number;
  @IsOptional()
  @IsNumber()
  reconGiftCard: number;
  @IsDefined()
  @IsNumber()
  reconHouseAccounts: number;
  @IsOptional()
  @IsNumber()
  reconTotalReconciled?: number;
  @IsOptional()
  @IsNumber()
  reconTotalToReconcile?: number;
  @IsDefined()
  @IsNumber()
  pettyCash: number;
  @Exclude()
  note?: string;
  @Exclude()
  multiCurrency?: BankingCashUpMultiCurrencyDto[];
  @Exclude()
  merchant?: MerchantDto;
  @Exclude()
  lastModifiedUser?: UserDto;
}
